import {Store} from '@gongxigames/framework/core/fragments/store/Store';

export const soundStore = Store.createStore({
    slot_soundMuted: Store.signal(false),
});